import { services } from '../../../../api/feathers';

export const GET_ACCOUNT_ADDRESSES = 'GET_ACCOUNT_ADDRESSES';
export const ADD_ACCOUNT_ADDRESS = 'ADD_ACCOUNT_ADDRESS';
export const UPDATE_ACCOUNT_ADDRESS = 'UPDATE_ACCOUNT_ADDRESS';
export const REMOVE_ACCOUNT_ADDRESS = 'REMOVE_ACCOUNT_ADDRESS';

/* ------------------------------------------------------------------ */
/* Helpers                                                            */
/* ------------------------------------------------------------------ */
const toNumberOrNull = (val) =>
  val !== undefined && val !== '' ? Number(val) : null;

/* ------------------------------------------------------------------ */
/* Thunks                                                             */
/* ------------------------------------------------------------------ */
export function getAccountAddresses(accountId) {
  return (dispatch) =>
    services.accountAddress
      .find({
        query: {
          accountId,
          $sort: { createdAt: 1 },
        },
      })
      .then((response) =>
        dispatch({ type: GET_ACCOUNT_ADDRESSES, payload: response.data })
      );
}

export function addAccountAddress(address) {
  const payload = {
    ...address,
    latitude: toNumberOrNull(address.latitude),
    longitude: toNumberOrNull(address.longitude),
  };

  return (dispatch) =>
    services.accountAddress
      .create(payload)
      .then(() => dispatch(getAccountAddresses(address.accountId)));
}

export function updateAccountAddress(id, address) {
  const payload = {
    ...address,
    latitude: toNumberOrNull(address.latitude),
    longitude: toNumberOrNull(address.longitude),
  };

  return (dispatch) =>
    services.accountAddress
      .patch(id, payload)
      .then(() => dispatch(getAccountAddresses(address.accountId)));
}

export function removeAccountAddress(id) {
  return (dispatch, getState) =>
    services.accountAddress.remove(id).then((removed) => {
      dispatch({ type: REMOVE_ACCOUNT_ADDRESS, payload: removed });
      const accId = removed.accountId || getState().auth?.user?.accountId;
      if (accId) dispatch(getAccountAddresses(accId));
    });
}
